import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormGroup from "@material-ui/core/FormGroup/FormGroup";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
// import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography/Typography";
import Save from "@material-ui/icons/Save";
import * as React from "react";
import { ChangeEvent } from "react";
import { IContentForm } from "./icontent-form";
import { OpinionEditorialModel } from "../../model/autogen/OpinionEditorialModel"
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { UserLevel } from "../../model/autogen/UserLevel";
import { withEditorPage } from "../../pages/editor-page";
import { OpinionEditorialsRequestFactory } from "../../model/autogen/OpinionEditorialsController"
import { WithDefaultStyles } from "../../utils/createStyles";
import { findTagsHelper, resolveTagsHelper } from "./form-state-helper";
import { strIsNullOrEmpty } from "../../utils/string";
import { RTEField } from "./rte-field";
import TagListEditor from "../material/tag-list-editor";
import { TagModel } from "../../model/autogen/TagModel";
import DatePicker from "material-ui-pickers/DatePicker";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Keyboard from "@material-ui/icons/Keyboard";
import * as moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../date-display-format";
import { isArrayNullOrEmpty } from "../../utils/array";
import { FilesRequestFactory } from "../../model/autogen/FilesController";
import { Spacer } from "../../components/utility-components";
import TextField from "@material-ui/core/TextField/TextField";
import { UploadSection } from "./upload-section";

export interface IOpinionEditorialProps extends IContentForm<OpinionEditorialModel> {
}

export interface IOpinionEditorialState extends OpinionEditorialModel {
    isSaving: boolean;
    isUploadingFiles: boolean;
}

type OpinionEditorialFormComponentProps = IOpinionEditorialProps & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles;


export class OpinionEditorialFormComponent extends React.Component<OpinionEditorialFormComponentProps, IOpinionEditorialState> {
    constructor(props: OpinionEditorialFormComponentProps) {
        super(props);
        this.state = { ...props.item, isUploadingFiles: false, isSaving: false };
    }

    private onTextChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    };

    private onDateChanged = (date: moment.Moment) => {
        this.setState({ dateField: date.toDate() });
    }

    private onSave = async (e: any) => {
        const {isSaving, ...payload } = this.state;
        const { callApi, showSnackbarMessage } = this.props;
        this.setState({ isSaving: true });
        try {
            const result = await callApi((fetcher) => (payload.id > 0 ? OpinionEditorialsRequestFactory.update : OpinionEditorialsRequestFactory.create)(fetcher, payload));
            showSnackbarMessage(payload.id > 0 ? 'Opinion Editorial Saved' : `New Opinion Editorial Save (${result.documentId})`);
            
            this.props.onSaveCompleted();
        } catch (e) {
            showSnackbarMessage(`Error saving Opinion Editorial: ${e}`);
            this.setState({ isSaving: false});
        }
    }
    private onTagsChanged = (tags: TagModel[]) => {
        this.setState({ createTags: tags });
    }

    private onSearchTags = (query: string, isResourceOnly: boolean) => {
        return findTagsHelper(this.props.callApi, query, isResourceOnly);
    }

    private onResolveTags = (tags: string[]) => {
        return resolveTagsHelper(this.props.callApi, tags);
    }

    private onFileDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        const { callApi } = this.props;
        try {
            if (!isArrayNullOrEmpty(acceptedFiles)) {
                this.setState({ isUploadingFiles: true});
                const result = await callApi(f => FilesRequestFactory.upload(f, { file: acceptedFiles[0] }))
                const { assignFiles } = this.state;
                this.setState({ isUploadingFiles: false, assignFiles: [...(assignFiles || []), result]});
            }
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to upload file: ${e}`);
            this.setState({ isUploadingFiles: false });
        }
    }
    public render(): JSX.Element {
        const { dateField, summary, body, isSaving, isUploadingFiles, assignFiles, files, title } = this.state;
        const cannotSave = isSaving || strIsNullOrEmpty(summary)
        return <>
            <FormControl component={"fieldset" as "div"} fullWidth={true}>
                <Typography variant="h5">{!this.props.item.id ? 'New' : ''} Opinion Editorial Details</Typography>
                <Spacer/>
                <FormGroup>
                    <FormControl>
                        <TextField label="Opinion Editorial Title" rows={2} rowsMax={4} multiline={true} fullWidth={true} name="title" value={title} onChange={this.onTextChange} disabled={isSaving} />
                        <DatePicker format={DATE_DISPLAY_FORMAT} label="Date" autoOk clearable showTodayButton value={dateField} onChange={this.onDateChanged} leftArrowIcon={<ChevronLeft />} rightArrowIcon={<ChevronRight />} keyboardIcon={<Keyboard />} />
                        <Spacer/>
                        <FormLabel>Summary</FormLabel>
                        <RTEField name="summary" value={summary} onChange={this.onTextChange} />
                        <Spacer/>
                        <FormLabel>Body</FormLabel>
                        <RTEField name="body" value={body} onChange={this.onTextChange} />
                    </FormControl>
                    <Spacer/>
                    <UploadSection onFileDrop={this.onFileDrop} isUploadingFiles={isUploadingFiles} files={files} assignFiles={assignFiles} />
                    <Spacer/>
                    <FormControl>
                        <FormLabel>Tags</FormLabel>
                        <TagListEditor isResourceOnly={false} initialTags={this.props.item.tags} onTagsChanged={this.onTagsChanged} onFetchTags={this.onSearchTags} onResolveTags={this.onResolveTags} />
                    </FormControl>
                    <Button variant="contained" fullWidth={true} onClick={this.onSave} disabled={isSaving || cannotSave} color="primary">
                        {isSaving ? <CircularProgress size={24} /> : <Save />}{isSaving ? " Saving ..." : " Save"}
                    </Button>
                </FormGroup>
            </FormControl>
        </>
    }

}

// HACK: wrapper to workaround the fact that our current codegen doesn't support argument default values, so there's a signature mismatch
const opinionEditorialGet = (fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number) => OpinionEditorialsRequestFactory.getById(fetcher, id, false);

export const OpinionEditorialForm = withSnackbar(withAuthContext(OpinionEditorialFormComponent, UserLevel.Editor)) as React.ComponentType<IOpinionEditorialProps>;

export const OpinionEditorialEditPage = withAuthContext(withEditorPage(OpinionEditorialForm as any, opinionEditorialGet), UserLevel.SystemUser) as React.ComponentType<IOpinionEditorialProps>;


// WEBPACK FOOTER //
// ./src/components/forms/opinion-editorial-form.tsx